<template>
  <v-container>
    <div class="d-flex justify-end align-center mb-3">
      <div class="text-subtitle-2 font-weight-light grey--text">
        Vous possédez déjà un compte ?
      </div>
      <SButton
        color="primaryColor"
        icon="fa-arrow-right-to-bracket"
        outlined
        @click="$router.push({ name: 'Login' })"
      >
        Identifiez-vous
      </SButton>
    </div>
    <div class="text-h3 font-weight-bold primaryColor--text text-center my-6">
      Créer un compte
    </div>
    <div class="d-flex justify-center align-center my-5">
      <v-btn class="mx-3" elevation="2" small fab raised color="#3B5998">
        <v-icon color="white" small>fa-facebook</v-icon>
      </v-btn>
      <v-btn class="mx-3" elevation="2" small fab raised color="#DB4437">
        <v-icon color="white" small @click="submitGoogle()">fa-google</v-icon>
      </v-btn>
    </div>
    <div class="text-subtitle-2 font-weight-light grey--text text-center">
      Ou créer avec votre email
    </div>
    <form @submit.prevent="submit()" class="form-login my-10">
      <STextField
        label="Email"
        v-model="form.email"
        icon="fa-envelope"
        :error-messages="$fieldValidator('Email', $v.form.email)"
        @input="$v.form.email.$touch()"
        @blur="$v.form.email.$touch()"
      />

      <SPasswordField
        v-model="form.password"
        hint="Les mots de passe doivent au moins avoir 6 caractères."
        persistent-hint
        :error-messages="$fieldValidator('Mot de passe', $v.form.password)"
        @input="$v.form.password.$touch()"
        @blur="$v.form.password.$touch()"
      />

      <SPasswordField
        label="Confirmer le mot de passe"
        v-model="form.confirmPassword"
        :error-messages="
          $fieldValidator('Mot de passe', $v.form.confirmPassword)
        "
        @input="$v.form.confirmPassword.$touch()"
        @blur="$v.form.confirmPassword.$touch()"
      />

      <v-btn
        large
        type="submit"
        color="primaryColor"
        :loading="loading"
        :disabled="$v.$invalid"
        class="ma-1 white--text"
      >
        s'inscrire <v-icon right dark> fa-check </v-icon>
      </v-btn>
    </form>

    <SAlert v-model="alert" :message="message" error @onClose="alert = false" />
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";

import { mapActions } from "vuex";

export default {
  name: "RegisterForm",
  mixins: [validationMixin],
  validations: {
    form: {
      email: {
        email,
        required,
      },
      password: {
        required,
        minLength: minLength(6),
      },
      confirmPassword: {
        sameAsPassword: sameAs("password"),
      },
    },
  },
  data: () => ({
    form: {
      email: "",
      password: "",
      confirmPassword: "",
    },
    loading: false,
    alert: false,
    message: "",
  }),
  methods: {
    ...mapActions({
      emailRegister: "auth/emailRegister",
      googleRegister: "auth/googleRegister",
    }),
    async submit() {
      if (!this.$v.invalid) {
        this.loading = true;
        try {
          await this.emailRegister(this.form);
          this.$router.push({ name: "FinishRegister" });
        } catch ({ error }) {
          this.message = error;
          this.alert = true;
        }
      }
      this.loading = false;
    },
    async submitGoogle() {
      try {
        await this.googleRegister();
        this.$router.push({ name: "FinishRegister" });
      } catch ({ error }) {
        this.message = error;
        this.alert = true;
      }
    },
  },
};
</script>

<style scoped>
.form-login {
  width: 60%;
  display: block;
  justify-content: center;
  margin: auto;
  text-align: center;
}
</style>
